import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';

const GlobalPopup = ({ open, title, message, onClose, onConfirm, cancel, ok, cancelClassName }) => (
  <Dialog open={open} onClose={onClose}>
    {title && <DialogTitle>{title}</DialogTitle>}
    <DialogContent>{message}</DialogContent>
    <DialogActions sx={{display:'flex', flexWrap:'wrap'}}>
      <Button sx={{ textTransform: 'none' }} onClick={onConfirm} variant="contained"  className='bnt-popup-ok'>
        {ok ? ok : 'Ok'}
      </Button>
      {cancel && <Button sx={{ textTransform: 'none' }} onClick={onClose} className={cancelClassName || 'bnt-popup-cancel'}> {cancel ? cancel : 'Cancel'}</Button>}
    </DialogActions>
  </Dialog>
);

export default GlobalPopup;
